// Product catalog (frontend display data). Prices/IDs MUST match backend PRODUCTS.
export const PRODUCTS = [
  {
    id: "surron-lbx",
    slug: "surron-lbx",
    category: "bike",
    name: "SUR-RON LIGHT BEE X",
    tagline: "/ TRAIL / OFF-ROAD",
    shortDesc: "Lightweight electric off-road predator",
    price: 200,
    image:
      "https://cdn11.bigcommerce.com/s-nlkkuaauhz/images/stencil/500x659/products/112/379/surron_rst_01__73314.1614119447.jpg?c=1",
    description:
      "The SUR-RON Light Bee X is the bike that started the electric off-road revolution. At just 50 kg, it dances through singletrack with a 6kW peak mid-drive motor, instant torque, and a custom-tuned controller. Hydraulic disc brakes, full suspension, and a 60V/40Ah battery make it the lightest weapon in your garage.",
    specs: [
      { label: "Motor", value: "6kW Peak Mid-Drive" },
      { label: "Top Speed", value: "75 km/h" },
      { label: "Range", value: "100 km" },
      { label: "Weight", value: "50 kg" },
    ],
    colors: [
      {
        name: "Forest Green",
        hex: "#7a8c2b",
        image: "https://customer-assets.emergentagent.com/job_ebike-store-v2/artifacts/8bwo8bnw_image.png",
      },
      {
        name: "Purple",
        hex: "#5d3a8a",
        image: "https://customer-assets.emergentagent.com/job_ebike-store-v2/artifacts/0neyxe0s_image.png",
      },
      {
        name: "Ocean Blue",
        hex: "#1f4b78",
        image: "https://customer-assets.emergentagent.com/job_ebike-store-v2/artifacts/vbu9c158_image.png",
      },
    ],
  },
  {
    id: "surron-ultra-bee-x",
    slug: "surron-ultra-bee-x",
    category: "bike",
    name: "SUR-RON ULTRA BEE X",
    tagline: "/ ENDURO / TRAIL",
    shortDesc: "12.5 kW mid-drive. 324 ft-lbs. Break the boundaries.",
    price: 350,
    image:
      "https://sur-ron.co.uk/wp-content/uploads/2026/01/ultra-bee-R-45%C2%B0-right-1-1.png",
    description:
      "The Ultra Bee X is SUR-RON's full-size enduro weapon. A 12.5 kW peak mid-drive cranks out 324 ft-lbs of wheel torque, a 74V/55Ah battery delivers serious range, and the inverted forks plus full-size 19/19 wheels turn fire roads into a playground. Built for riders who want raw power without the petrol smell.",
    specs: [
      { label: "Motor", value: "12.5 kW Peak Mid-Drive" },
      { label: "Top Speed", value: "90 km/h" },
      { label: "Range", value: "130 km" },
      { label: "Weight", value: "85 kg" },
    ],
    colors: [
      {
        name: "Brown",
        hex: "#7a5a3a",
        image: "https://customer-assets.emergentagent.com/job_ebike-store-v2/artifacts/0e0dgpy9_image.png",
      },
      {
        name: "Graphite Black",
        hex: "#1a1a1a",
        image: "https://customer-assets.emergentagent.com/job_ebike-store-v2/artifacts/jyxry6i3_image.png",
      },
    ],
  },
  {
    id: "stark-varg",
    slug: "stark-varg",
    category: "bike",
    name: "STARK VARG",
    tagline: "/ MOTOCROSS / PRO",
    shortDesc: "80 HP. Fastest electric motocross bike in the world.",
    price: 500,
    image:
      "https://thepack.news/wp-content/uploads/2021/12/Stark_Future_side_view_1-1024x683.jpg",
    description:
      "The Stark Varg is, on paper and on track, the most powerful production motocross bike ever built. 80 HP, 938 Nm at the rear wheel, and a carbon-magnesium chassis weighing in lighter than a 450cc thumper. The 6 kWh battery is the structural core, and the dashboard is your own phone, mapped per-rider, per-track.",
    specs: [
      { label: "Power", value: "80 HP" },
      { label: "Torque", value: "938 Nm (wheel)" },
      { label: "Battery", value: "6 kWh" },
      { label: "Weight", value: "118 kg" },
    ],
    colors: [
      { name: "Red", hex: "#b71c1c", filter: "hue-rotate(-5deg) saturate(1.3) brightness(0.9)" },
      {
        name: "White",
        hex: "#ededed",
        image: "https://customer-assets.emergentagent.com/job_ebike-store-v2/artifacts/u2j2sxd2_image.png",
      },
      { name: "Grey", hex: "#6b6b6b", filter: "grayscale(1) brightness(0.85) contrast(1)" },
    ],
  },
  {
    id: "kukirin-g2-pro",
    slug: "kukirin-g2-pro",
    category: "scooter",
    name: "KUKIRIN G2 PRO",
    tagline: "/ URBAN / COMMUTER",
    shortDesc: "800W of nimble city power with off-road appetite.",
    price: 250,
    image: "/images/scooters/g2-pro.png",
    description:
      "The KuKirin G2 Pro is the sweet spot between commuter and weekend toy. An 800W rear hub motor pushes it to 45 km/h, while the 48V 15Ah battery covers up to 55 km per charge. Front and rear spring suspension plus 9-inch off-road tires soak up broken tarmac, and dual disc brakes keep it all under control.",
    specs: [
      { label: "Motor", value: "800W Rear Hub" },
      { label: "Top Speed", value: "45 km/h" },
      { label: "Range", value: "55 km" },
      { label: "Battery", value: "48V 15Ah" },
    ],
    colors: [{ name: "Black / Orange Accents", hex: "#1a1a1a" }],
  },
  {
    id: "kukirin-g2-max",
    slug: "kukirin-g2-max",
    category: "scooter",
    name: "KUKIRIN G2 MAX",
    tagline: "/ URBAN / LONG RANGE",
    shortDesc: "1000W motor, 80 km range. The endurance commuter.",
    price: 300,
    image: "/images/scooters/g2-max.png",
    description:
      "The G2 Max takes everything the Pro does and stretches it further. A 1000W motor lifts the top speed to 55 km/h, and the big 48V 20Ah pack is good for roughly 80 km of real riding. 10-inch off-road tires, dual suspension, and a bright full-color display make it the pick for riders who log serious daily distance.",
    specs: [
      { label: "Motor", value: "1000W Rear Hub" },
      { label: "Top Speed", value: "55 km/h" },
      { label: "Range", value: "80 km" },
      { label: "Battery", value: "48V 20Ah" },
    ],
    colors: [{ name: "Black / Orange Accents", hex: "#1c1c1c" }],
  },
  {
    id: "kukirin-g2-master",
    slug: "kukirin-g2-master",
    category: "scooter",
    name: "KUKIRIN G2 MASTER",
    tagline: "/ DUAL MOTOR / PERFORMANCE",
    shortDesc: "Dual 1000W motors. The G2 family flagship.",
    price: 450,
    image: "/images/scooters/g2-master.png",
    description:
      "The G2 Master is the flagship of the G2 line: twin 1000W motors deliver all-wheel-drive traction and a 65 km/h top end. A 52V 20.8Ah battery feeds the beast for up to 80 km, while hydraulic-feel suspension and dual disc brakes handle the speed. Climbs, gravel, launches — the Master doesn't flinch.",
    specs: [
      { label: "Motor", value: "Dual 1000W (AWD)" },
      { label: "Top Speed", value: "65 km/h" },
      { label: "Range", value: "80 km" },
      { label: "Battery", value: "52V 20.8Ah" },
    ],
    colors: [{ name: "All-Black / Orange Details", hex: "#141414" }],
  },
  {
    id: "kukirin-g3",
    slug: "kukirin-g3",
    category: "scooter",
    name: "KUKIRIN G3",
    tagline: "/ ADVENTURE / OFF-ROAD",
    shortDesc: "1200W adventure scooter built for rough ground.",
    price: 250,
    image: "/images/scooters/g3.png",
    description:
      "The KuKirin G3 is the adventure-tourer of the range. A 1200W motor hits 50 km/h, the 52V 18Ah battery covers around 60 km, and the long-travel front suspension with 10.5-inch off-road tires turns trails and torn-up streets into smooth sailing. Foldable, tough, and famously fun.",
    specs: [
      { label: "Motor", value: "1200W Rear Hub" },
      { label: "Top Speed", value: "50 km/h" },
      { label: "Range", value: "60 km" },
      { label: "Battery", value: "52V 18Ah" },
    ],
    colors: [{ name: "Matte Black / Orange Frame", hex: "#181818" }],
  },
  {
    id: "kukirin-g3-pro",
    slug: "kukirin-g3-pro",
    category: "scooter",
    name: "KUKIRIN G3 PRO",
    tagline: "/ DUAL MOTOR / EXTREME",
    shortDesc: "Dual 1200W motors and 65 km/h. Maximum KuKirin.",
    price: 550,
    image: "/images/scooters/g3-pro.png",
    description:
      "The G3 Pro is the most extreme scooter in the lineup. Dual 1200W motors (2400W combined) launch it to 65 km/h with all-wheel drive, and the massive 52V 23.2Ah battery keeps it running for up to 80 km. Full suspension, hydraulic disc brakes, and 10.5-inch knobby tires make it a genuine off-road machine.",
    specs: [
      { label: "Motor", value: "Dual 1200W (AWD)" },
      { label: "Top Speed", value: "65 km/h" },
      { label: "Range", value: "80 km" },
      { label: "Battery", value: "52V 23.2Ah" },
    ],
    colors: [{ name: "Black / Orange Elements", hex: "#161616" }],
  },
  {
    id: "kukirin-g4",
    slug: "kukirin-g4",
    category: "scooter",
    name: "KUKIRIN G4",
    tagline: "/ HYPER / STREET",
    shortDesc: "2000W single motor, 70 km/h. Street missile.",
    price: 400,
    image: "/images/scooters/g4.png",
    description:
      "The KuKirin G4 packs a single 2000W motor that rockets to 70 km/h — the fastest single-motor scooter KuKirin makes. A 60V 20Ah battery delivers up to 75 km of range, while the motorcycle-style front fork, wide deck, and 11-inch tubeless off-road tires give it a planted, confidence-inspiring ride at speed.",
    specs: [
      { label: "Motor", value: "2000W Rear Hub" },
      { label: "Top Speed", value: "70 km/h" },
      { label: "Range", value: "75 km" },
      { label: "Battery", value: "60V 20Ah" },
    ],
    colors: [{ name: "Matte Black / Silver-Grey & Orange", hex: "#2b2b2b" }],
  },
];

export const getProductBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);
export const BIKES = PRODUCTS.filter((p) => p.category === "bike");
export const SCOOTERS = PRODUCTS.filter((p) => p.category === "scooter");
